<span *ngIf="inline !== true && control.invalid && control.dirty" class="p-inputgroup-addon" pTooltip="{{errors}}"><i class="pi pi-exclamation-triangle"></i></span>
<span *ngIf="inline === true && control.invalid && control.dirty" class="inline"><i class="pi pi-exclamation-triangle"></i> {{errors}}</span>
